import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';

/**
 * Component used to indicate progress in some process as regular progress bar.
 */
var ProgressBarComponent = /** @class */ (function (_super) {
    __extends(ProgressBarComponent, _super);
    function ProgressBarComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ProgressBarComponent.prototype, "progressValue", {
        /**
         * Make sure progress is a number between 0 and 100
         */
        get: function () {
            var progress = Math.round(Number(this.progress) || 0);
            if (progress < 0) {
                progress = 0;
            }
            if (progress > 100) {
                progress = 100;
            }
            return progress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProgressBarComponent.prototype, "isComplete", {
        get: function () {
            return this.progressValue === 100;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProgressBarComponent.prototype, "styles", {
        get: function () {
            if (!this.progressValue) {
                return {};
            }
            return {
                '--magic-progress-bar-width': this.progressValue + "%",
            };
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ type: Number, default: 0 }),
        __metadata("design:type", Number)
    ], ProgressBarComponent.prototype, "progress", void 0);
    __decorate([
        Prop({ type: Boolean }),
        __metadata("design:type", Boolean)
    ], ProgressBarComponent.prototype, "isTopNavigationEnabled", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], ProgressBarComponent.prototype, "bgClass", void 0);
    ProgressBarComponent = __decorate([
        Component({
            name: 'ui-progress-bar',
        })
    ], ProgressBarComponent);
    return ProgressBarComponent;
}(Mixins(MagicConfigMixin)));

export default ProgressBarComponent;
